import script from "./CollectIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectIndex.vue?vue&type=script&setup=true&lang=js"

import "./CollectIndex.vue?vue&type=style&index=0&id=426ef17d&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-426ef17d"]])

export default __exports__